import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { TableauDeBord } from '../tableau-de-bord/TableauDeBord';

const rechercheSchema = z.object({
  /** Portefeuille d'un mentor : restreint le tableau de bord, sauf la comparaison des mentors. */
  mentor: z.string().min(1).optional().catch(undefined),
});

export const Route = createFileRoute('/tableau-de-bord')({
  validateSearch: rechercheSchema,
  component: function PageTableauDeBord() {
    return <TableauDeBord mentor={Route.useSearch().mentor} />;
  },
});
